import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-angle-left",
  "use": "icon-s-angle-left-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-angle-left\"><path transform=\"matrix(-1 0 0 1 22.065 0)\" fill-rule=\"evenodd\" d=\"M17.0645161 11 6.41935484 22.0220965 5 20.6027416 14.2258065 11 5 1.41935484 6.41935484 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol